import { render, staticRenderFns } from "./LimitsManagement.vue?vue&type=template&id=5598f28c&scoped=true"
import script from "./LimitsManagement.vue?vue&type=script&lang=js"
export * from "./LimitsManagement.vue?vue&type=script&lang=js"
import style0 from "./LimitsManagement.vue?vue&type=style&index=0&id=5598f28c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5598f28c",
  null
  
)

export default component.exports